<div class="container" [ngClass]="type === 'total' ? 'bold' : null">
  <div class="container__title">
    {{ title }}
    @if (titleBelow) {
      <br />
      <span class="container__titleBelow">
        {{ titleBelow }}
      </span>
    }
  </div>
  <div class="container__flex">
    @if (type == 'zeroInstalment') {
      <div class="zero-instalment">
        {{ "common.zeroInstalment" | translate }}
      </div>
    }
    @if (type == 'bnplSubsidized') {
      <div class="zero-instalment">
        {{ "common.bnplSubsidized" | translate }}
      </div>
    }
    @if (memberDiscount) {
      <p class="tag">
        {{ "common.memberDisc" | translate }}
      </p>
    }
    <div
      class="container__bold"
      [ngClass]="
        type === 'discount'
          ? 'discount-color'
          : type == 'normal'
          ? 'no-bold'
          : null
      "
      >
      @if (type == 'discount') {
        <span>- </span>
      }
      @if (type == 'discount' || currency) {
        <span>RM </span>
        }{{ value }}
      </div>
    </div>
  </div>
